var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2433_4432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 3.33301C10.7999 3.33301 3.33325 10.7997 3.33325 19.9997C3.33325 29.1997 10.7999 36.6663 19.9999 36.6663C29.1999 36.6663 36.6666 29.1997 36.6666 19.9997C36.6666 10.7997 29.1999 3.33301 19.9999 3.33301ZM19.9999 33.333C12.6499 33.333 6.66659 27.3497 6.66659 19.9997C6.66659 12.6497 12.6499 6.66634 19.9999 6.66634C27.3499 6.66634 33.3333 12.6497 33.3333 19.9997C33.3333 27.3497 27.3499 33.333 19.9999 33.333ZM27.6499 12.633L16.6666 23.6163L12.3499 19.3163L9.99992 21.6663L16.6666 28.333L29.9999 14.9997L27.6499 12.633Z",
    fill: "#A28957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2433_4432"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/checkCircle.54609200c2618ba5e98bbedfe4a0899a.svg";
export { ForwardRef as ReactComponent };